import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { mainWebsitePath } from "../../services/util";

class PageFooter extends Component {
    constructor() {
        super();
        this.state = {
            className: "col-md-12 col-xs-12",
        };
        this.renderContactDetails = this.renderContactDetails.bind(this);
        this.onPageClick = this.onPageClick.bind(this);
        this.renderCategories = this.renderCategories.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.onMenuSelected = this.onMenuSelected.bind(this);

    }

    componentDidMount() {
        // console.log('this.props.config', this.props.config)
        let sectionCount = 1;
        if (
            this.props.config.CheckoutConfig.hasOwnProperty(
                "ShowContactDetailsInFooter"
            ) &&
            this.props.config.CheckoutConfig.ShowContactDetailsInFooter
        ) {
            sectionCount += 1;
        }
        if (this.props.pages.filter((f) => f.ShowInFooter).length > 0) {
            sectionCount += 1;
        }
        if (
            this.props.config.CheckoutConfig.hasOwnProperty(
                "ShowSocialMediaDetailsInFooter"
            ) &&
            this.props.config.CheckoutConfig.ShowSocialMediaDetailsInFooter
        ) {
            sectionCount += 1;
        }
        if (sectionCount > 1) {
            let className = "col-md-" + (12 / sectionCount).toString();
            this.setState({ className: className });
        }
    }

    onMenuSelected(menu){
        console.log('menu',menu)
        if(menu.Type.toLowerCase()==="home"){
            this.props.history.push(mainWebsitePath());
        }
        else if(menu.Type.toLowerCase()==="categorylink"){
            this.props.history.push(mainWebsitePath() + "l1/" + menu.Tag);
        }
        else if(menu.Type.toLowerCase()==="subcategorylink"){
            this.props.history.push(mainWebsitePath() + "l2/" + menu.Tag);
        }
        else if(menu.Type.toLowerCase()==="productgrouplink"){
            this.props.history.push(mainWebsitePath() + "pg/" + menu.Tag);
        }
        else if(menu.Type.toLowerCase()==="productlink"){
            this.props.history.push(mainWebsitePath() + "l3/" + menu.Tag);
        }
        else if(menu.Type.toLowerCase()==="pagelink"){
            this.props.history.push(mainWebsitePath() + "pages/" + menu.Tag);
        }
        else if(menu.Type.toLowerCase()==="brandlink"){
            this.props.history.push(mainWebsitePath() + "b/" + menu.Tag);
        }
        else if(menu.Type.toLowerCase()==="contactuslink"){
            this.props.history.push(mainWebsitePath() + "contact/");
        }
    
    }


    onPageClick(m) {
        const { history } = this.props;
        history.push(mainWebsitePath() + "pages/" + m.Title);
    }

    // renderContactDetails()
    // {

    //   return <React.Fragment>
    //         <div style={{ paddingTop: "10px",textAlign:"center" }}>
    //             <div className="col-12">
    //                 <b>Contact Details</b>
    //                 <br/>
    //                 {(this.props.config.CheckoutConfig.hasOwnProperty('EmailID') && this.props.config.CheckoutConfig.EmailID.trim() !=="") && <div style={{display:"inline-block", margin:"10px"}}
    //                 onClick={()=>{this.props.history.push(mainWebsitePath() + "Contact");}}>
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 480" width="24px"><g><g><path d="M456,72H24C10.745,72,0,82.745,0,96v288c-0.015,5.043,1.579,9.959,4.552,14.032C9.058,404.285,16.293,407.993,24,408h432    c7.696-0.005,14.922-3.7,19.432-9.936c2.98-4.083,4.581-9.009,4.568-14.064V96C480,82.745,469.255,72,456,72z M16,379.416V124.608    L180.92,252L16,379.416z M25.88,392L194,262.112l31.336,24.192c8.639,6.668,20.689,6.668,29.328,0L286,262.112L454.12,392H25.88z     M464,379.416L299.08,252L464,124.608V379.416z M464,104.392L244.888,273.64c-2.88,2.223-6.896,2.223-9.776,0L16,104.392V96    c0-4.418,3.582-8,8-8h432c4.418,0,8,3.582,8,8V104.392z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
    //                     <div className="footer-text">{this.props.config.CheckoutConfig.EmailID}</div>
    //                 </div>}
    //                 {(this.props.config.CheckoutConfig.hasOwnProperty('ContactNo') && this.props.config.CheckoutConfig.ContactNo.trim() !=="") && <div style={{display:"inline-block", margin:"10px"}}>
    //                     <a href={"tel:"+  this.props.config.CheckoutConfig.ContactNo.trim()} style={{color:"black"}}>
    //                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.076 512.076" width="24px"><g transform="translate(-1 -1)"><g><g><path d="M499.639,396.039l-103.646-69.12c-13.153-8.701-30.784-5.838-40.508,6.579l-30.191,38.818     c-3.88,5.116-10.933,6.6-16.546,3.482l-5.743-3.166c-19.038-10.377-42.726-23.296-90.453-71.04s-60.672-71.45-71.049-90.453     l-3.149-5.743c-3.161-5.612-1.705-12.695,3.413-16.606l38.792-30.182c12.412-9.725,15.279-27.351,6.588-40.508l-69.12-103.646     C109.12,1.056,91.25-2.966,77.461,5.323L34.12,31.358C20.502,39.364,10.511,52.33,6.242,67.539     c-15.607,56.866-3.866,155.008,140.706,299.597c115.004,114.995,200.619,145.92,259.465,145.92     c13.543,0.058,27.033-1.704,40.107-5.239c15.212-4.264,28.18-14.256,36.181-27.878l26.061-43.315     C517.063,422.832,513.043,404.951,499.639,396.039z M494.058,427.868l-26.001,43.341c-5.745,9.832-15.072,17.061-26.027,20.173     c-52.497,14.413-144.213,2.475-283.008-136.32S8.29,124.559,22.703,72.054c3.116-10.968,10.354-20.307,20.198-26.061     l43.341-26.001c5.983-3.6,13.739-1.855,17.604,3.959l37.547,56.371l31.514,47.266c3.774,5.707,2.534,13.356-2.85,17.579     l-38.801,30.182c-11.808,9.029-15.18,25.366-7.91,38.332l3.081,5.598c10.906,20.002,24.465,44.885,73.967,94.379     c49.502,49.493,74.377,63.053,94.37,73.958l5.606,3.089c12.965,7.269,29.303,3.898,38.332-7.91l30.182-38.801     c4.224-5.381,11.87-6.62,17.579-2.85l103.637,69.12C495.918,414.126,497.663,421.886,494.058,427.868z"/><path d="M291.161,86.39c80.081,0.089,144.977,64.986,145.067,145.067c0,4.713,3.82,8.533,8.533,8.533s8.533-3.82,8.533-8.533     c-0.099-89.503-72.63-162.035-162.133-162.133c-4.713,0-8.533,3.82-8.533,8.533S286.448,86.39,291.161,86.39z"/><path d="M291.161,137.59c51.816,0.061,93.806,42.051,93.867,93.867c0,4.713,3.821,8.533,8.533,8.533     c4.713,0,8.533-3.82,8.533-8.533c-0.071-61.238-49.696-110.863-110.933-110.933c-4.713,0-8.533,3.82-8.533,8.533     S286.448,137.59,291.161,137.59z"/><path d="M291.161,188.79c23.552,0.028,42.638,19.114,42.667,42.667c0,4.713,3.821,8.533,8.533,8.533s8.533-3.82,8.533-8.533     c-0.038-32.974-26.759-59.696-59.733-59.733c-4.713,0-8.533,3.82-8.533,8.533S286.448,188.79,291.161,188.79z"/></g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
    //                         <div className="footer-text">{this.props.config.CheckoutConfig.ContactNo.trim()}</div>
    //                     </a>
    //                 </div>}
    //                 {(this.props.config.CheckoutConfig.hasOwnProperty('WhatsAppNo') && this.props.config.CheckoutConfig.WhatsAppNo.trim() !=="") &&<div style={{display:"inline-block", margin:"10px"}}
    //                 onClick={() => { window.open('https://wa.me/91' + this.props.config.CheckoutConfig.WhatsAppNo.trim()) }}>
    //                     <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 465 465" width="24px"><g><path d="M343.047,294.476c-17.105-17.104-35.09-31.282-35.847-31.877c-2.985-2.345-7.252-2.093-9.938,0.593l-21.203,21.204   l-56.917-56.917c-2.93-2.928-7.678-2.928-10.607,0c-2.929,2.93-2.929,7.678,0,10.607l62.221,62.22c2.93,2.928,7.678,2.928,10.607,0   l21.726-21.727c6.529,5.398,18.266,15.417,29.352,26.504c11.12,11.119,21.165,22.892,26.552,29.41   c-10.076,9.812-28.982,25.597-43.045,26.893c-28.911,2.669-83.581-29.971-132.971-79.36   c-49.391-49.389-82.025-104.069-79.361-132.973c1.296-14.063,17.083-32.971,26.894-43.045c6.513,5.382,18.275,15.418,29.409,26.553   c11.087,11.086,21.106,22.822,26.504,29.353l-21.726,21.725c-1.407,1.407-2.197,3.314-2.197,5.304s0.79,3.896,2.196,5.304   l22.627,22.627c2.93,2.928,7.678,2.928,10.607,0c2.929-2.93,2.929-7.678,0-10.607l-17.324-17.323l21.203-21.202   c2.686-2.686,2.94-6.953,0.594-9.938c-0.595-0.757-14.772-18.742-31.877-35.848c-17.105-17.105-35.091-31.282-35.848-31.877   c-2.894-2.272-7.006-2.115-9.713,0.377c-3.468,3.19-33.953,31.904-36.287,57.223c-3.092,33.554,30.541,91.808,83.691,144.957   c50.893,50.892,106.459,83.89,140.544,83.887c1.512,0,2.986-0.065,4.411-0.196c25.319-2.335,54.033-32.819,57.224-36.287   c2.49-2.707,2.65-6.82,0.377-9.713C374.329,329.566,360.152,311.582,343.047,294.476z"/><path d="M396.902,68.098C352.988,24.185,294.603,0,232.5,0S112.012,24.185,68.098,68.098C24.185,112.012,0,170.397,0,232.501   c0,45.764,13.241,89.906,38.329,127.906L9.94,445.572c-0.898,2.695-0.197,5.667,1.812,7.676c2.009,2.008,4.979,2.709,7.676,1.812   l85.165-28.388C142.592,451.759,186.734,465,232.5,465c62.103,0,120.488-24.185,164.402-68.098   C440.815,352.989,465,294.604,465,232.501C465,170.397,440.815,112.012,396.902,68.098z M232.5,450   c-43.987,0-86.365-13.071-122.553-37.801c-1.262-0.862-2.739-1.308-4.232-1.308c-0.796,0-1.597,0.127-2.371,0.385l-74.43,24.81   l24.811-74.43c0.741-2.225,0.4-4.668-0.923-6.604C28.071,318.864,15,276.486,15,232.501C15,112.57,112.57,15,232.5,15   S450,112.57,450,232.501C450,352.431,352.43,450,232.5,450z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
    //                     <div className="footer-text">{this.props.config.CheckoutConfig.WhatsAppNo.trim()}</div>
    //                 </div>}
    //             </div>
    //         </div>
    //   </React.Fragment>
    // }

    renderContactDetails() {
        return (
            <React.Fragment>
                <div className={this.state.className}>
                    <div className="page-footer-contact-details">
                        <b>Contact Details</b>
                        {/* <br /> */}

                        {/* {this.props.config.CheckoutConfig.hasOwnProperty('OfficeAddress') &&  OfficeAddress} */}

                        {this.props.config.CheckoutConfig.hasOwnProperty("EmailID") &&
                            this.props.config.CheckoutConfig.EmailID.trim() !=="" && (
                                <div className="page-footer-links"
                                    onClick={() => {
                                        this.props.history.push(mainWebsitePath() + "Contact");
                                    }}
                                >
                                    <i className="fa fa-envelope"></i>
                                    &nbsp;
                                    <span className="footer-text">
                                        {this.props.config.CheckoutConfig.EmailID}
                                    </span>
                                </div>
                            )}
                        {this.props.config.CheckoutConfig.hasOwnProperty("ContactNo") &&
                            this.props.config.CheckoutConfig.ContactNo.trim() !=="" && (
                                <div className="page-footer-links">
                                    <a href={"tel:" +this.props.config.CheckoutConfig.ContactNo.trim()}>
                                        <i className="fa fa-phone"></i>
                                        &nbsp;
                                        <span className="footer-text">
                                            {this.props.config.CheckoutConfig.ContactNo.trim()}
                                        </span>
                                    </a>
                        </div>)}
                        {this.props.config.CheckoutConfig.hasOwnProperty("WhatsAppNo") &&
                            this.props.config.CheckoutConfig.WhatsAppNo.trim() !=="" && (
                                <div className="page-footer-links"
                                    onClick={() => {
                                        window.open("https://wa.me/91" + this.props.config.CheckoutConfig.WhatsAppNo.trim());
                                    }}
                                >
                                    <i className="fa fa-whatsapp"></i>
                                    &nbsp;
                                    <span className="footer-text">
                                        {this.props.config.CheckoutConfig.WhatsAppNo.trim()}
                                    </span>
                                </div>
                            )}
                            {this.props.config.CheckoutConfig.hasOwnProperty("OfficeAddress") &&
                            this.props.config.CheckoutConfig.OfficeAddress.trim() !=="" && (
                                <div className="page-footer-address"
                                dangerouslySetInnerHTML={{
                                    __html: this.props.config.CheckoutConfig.OfficeAddress,
                                }}
                                />
                            )}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderSocialMediaDetails() {
        return (
            <div className={this.state.className}>
                <div className="page-footer-socialmedia-details">
                    <b>Follows us on</b>
                    <div>
                        {this.props.config.CheckoutConfig.hasOwnProperty(
                            "FacebookURL"
                        ) &&
                            this.props.config.CheckoutConfig.FacebookURL.trim() !==
                                "" && (
                                <a
                                    href={this.props.config.CheckoutConfig.FacebookURL.trim()}
                                    target="_blank"
                                >
                                    <i className="fa fa-facebook"></i>
                                    <span>Facebook</span>
                                </a>
                            )}

                        {this.props.config.CheckoutConfig.hasOwnProperty(
                            "InstagramURL"
                        ) &&
                            this.props.config.CheckoutConfig.InstagramURL.trim() !==
                                "" && (
                                <a
                                    href={this.props.config.CheckoutConfig.InstagramURL.trim()}
                                    target="_blank"
                                >
                                    <i className="fa fa-instagram"></i>
                                    <span>Instagram</span>
                                </a>
                            )}

                        {this.props.config.CheckoutConfig.hasOwnProperty(
                            "TwitterURL"
                        ) &&
                            this.props.config.CheckoutConfig.TwitterURL.trim() !==
                                "" && (
                                <a
                                    href={this.props.config.CheckoutConfig.TwitterURL.trim()}
                                    target="_blank"
                                >
                                    <i className="fa fa-twitter"></i>
                                    <span>Twitter</span>
                                </a>
                            )}
                    </div>

                    {this.props.config.CheckoutConfig.hasOwnProperty(
                        "YoutubeURL"
                    ) &&
                        this.props.config.CheckoutConfig.YoutubeURL.trim() !==
                            "" && (
                            <a
                                href={this.props.config.CheckoutConfig.YoutubeURL.trim()}
                                target="_blank"
                            >
                                <svg
                                    style={{ margin: "10px" }}
                                    width="20px"
                                    viewBox="0 0 455.731 455.731"
                                >
                                    <g>
                                        <path
                                            d="M200.399,337.104c0,0.56,0,1.26-0.31,1.65c-2.1,2.71-4.6,4.97-7.88,6.17c-2.85,1.04-5.12-0.23-5.72-3.19
                c-0.24-1.17-0.25-2.4-0.25-3.6c-0.01-22.05-0.07-67.26-0.1-67.81h-16.27c0,0.61-0.02,63.59,0.02,75.49
                c0.01,3.22,0.35,6.42,1.69,9.41c1.44,3.24,3.83,5.29,7.39,5.88c2.61,0.45,5.16,0.16,7.64-0.69c5.08-1.75,9.06-5.05,12.57-9.01
		        c0.31-0.35,0.64-0.69,1.23-1.32v9.88h16.31v-43.23c0-14.98,0-46.55,0-46.55l-16.32,0.04V337.104z"
                                        />
                                        <path
                                            d="M277.509,277.334c-3.44-7.33-10.67-9.27-16.94-7.7c-3.8,0.96-6.88,3.15-9.41,5.98c-0.84,0.95-1.76,2.79-1.76,2.79
                s0-27.07,0-40.01h-16.34v121.55h16.34v-6.82c0,0,1.16,1.23,1.58,1.68c3.75,4.07,8.3,6.3,13.91,6.35c6.9,0.07,11.7-3.27,13.88-9.83
                c1.01-3.05,1.34-6.19,1.35-9.37c0.02-16.99,0.02-33.98-0.01-50.97C280.109,286.284,279.539,281.665,277.509,277.334z
                M263.289,339.925c0,0.91-0.11,1.83-0.3,2.72c-0.75,3.56-3.46,5.16-7.3,4.37c-2.33-0.48-4.15-1.82-5.71-3.51
                c-0.07-0.08-0.53-0.7-0.53-0.7v-1.33l-0.04-53.97c0,0,0.35-1,1.12-1.67c1.92-1.7,4.04-2.77,6.69-2.51c2.26,0.22,4.06,1.26,4.9,3.35
                c0.63,1.59,1.13,3.36,1.14,5.06C263.339,307.794,263.309,323.854,263.289,339.925z"
                                        />
                                        <path
                                            d="M218.753,171.39c3.81,0,6.909-3.099,6.909-6.909v-48.751c0-3.81-3.1-6.909-6.909-6.909s-6.909,3.1-6.909,6.909v48.751
		        C211.843,168.29,214.943,171.39,218.753,171.39z"
                                        />
                                        <polygon
                                            points="169.909,238.405 113.309,238.405 113.309,255.824 132.379,255.824 132.379,359.955 150.799,359.955 
		        150.799,255.784 169.909,255.784 	"
                                        />
                                        <path
                                            d="M324.189,328.084v11.53c0,4.03-3.26,7.29-7.28,7.29c-4.03,0-7.29-3.26-7.29-7.29v-22.43h31.29c0,0,0.18-15.65,0.05-22.75
                    c-0.05-3.03-0.28-6.1-0.9-9.06c-1.62-7.68-5.75-13.47-13.48-16.01c-2.27-0.75-4.71-1.14-7.1-1.29c-7.95-0.51-14.91,1.76-20.35,7.85
                    c-4.77,5.33-6.43,11.75-6.44,18.71c-0.03,13.31-0.09,26.63,0.04,39.94c0.04,3.39,0.42,6.85,1.19,10.15
                    c1.66,7.09,5.53,12.66,12.36,15.74c4.99,2.26,10.26,2.37,15.58,1.59c8.58-1.26,14.43-5.86,17.26-14.15
                    c2.13-6.21,1.88-19.82,1.88-19.82H324.189z M309.619,290.685c0-4.02,3.26-7.29,7.29-7.29c4.02,0,7.28,3.27,7.28,7.29v12.59h-14.57
                    V290.685z"
                                        />
                                        <path
                                            d="M0,0v455.731h455.731V0H0z M256.735,94.99h16.596v68.821c0,0.912,0.073,1.834,0.233,2.728
                    c0.503,2.836,2.6,4.171,5.331,3.224c3.329-1.152,5.87-3.457,8.024-6.173c0.306-0.388,0.25-1.112,0.25-1.681V94.99h16.717
                    l-0.005,90.244H287.16l0.02-9.695c-1.849,1.821-3.427,3.522-5.161,5.05c-3.074,2.708-6.556,4.727-10.629,5.524
                    c-6.253,1.222-11.579-0.754-13.573-7.23c-0.664-2.157-1.065-4.482-1.082-6.734V94.99z M218.753,92.731L218.753,92.731
                    c13.224,0,23.944,10.72,23.944,23.944v46.859c0,13.224-10.72,23.944-23.944,23.944l0,0c-13.224,0-23.944-10.72-23.944-23.944
                    v-46.859C194.808,103.451,205.528,92.731,218.753,92.731z M154.343,63.07c0,0,7.605,32.301,11.235,47.602h0.006
                    c3.63-15.301,11.235-47.602,11.235-47.602h19.029c0,0-14.62,48.487-21.158,70.111c-0.236,0.781-0.343,1.631-0.343,2.45
                    l0.008,49.584h-17.547l0.007-49.584c0-0.819-0.108-1.668-0.343-2.45c-6.538-21.624-21.158-70.111-21.158-70.111H154.343z
                    M363.579,350.865c0,22.18-17.72,40.3-39.89,40.77c-63.87,1.37-127.77,1.37-191.65,0c-22.16-0.47-39.88-18.59-39.88-40.77v-99.76
                    c0-22.17,17.72-40.29,39.88-40.76c63.88-1.37,127.78-1.37,191.65,0c22.17,0.47,39.89,18.59,39.89,40.76V350.865z"
                                        />
                                    </g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </a>
                        )}
                    {this.props.config.CheckoutConfig.hasOwnProperty(
                        "PinterestURL"
                    ) &&
                        this.props.config.CheckoutConfig.PinterestURL.trim() !==
                            "" && (
                            <a
                                href={this.props.config.CheckoutConfig.PinterestURL.trim()}
                                target="_blank"
                            >
                                <svg
                                    style={{ margin: "10px" }}
                                    width="20px"
                                    viewBox="0 0 504 504"
                                >
                                    <g>
                                        <g>
                                            <path
                                                d="M377.6,0H126C56.8,0,0,56.8,0,126.4V378c0,69.2,56.8,126,126,126h251.6c69.6,0,126.4-56.8,126.4-126.4V126.4
			C504,56.8,447.2,0,377.6,0z M277.2,322c-20,0-39.2-10.4-45.6-22.4c0,0-10.8,41.6-13.2,49.6c-8,28.4-32,56.8-33.6,59.2
			c-1.2,1.6-4,1.2-4.4-1.2c-0.4-3.6-6.4-39.6,0.4-68.8c3.6-14.8,24-98.4,24-98.4s-6-11.6-6-28.4c0-26.8,16-46.8,36-46.8
			c16.8,0,25.2,12.4,25.2,27.2c0,16.4-10.8,41.2-16.4,64c-4.8,19.2,10,34.8,29.6,34.8c35.2,0,59.2-44,59.2-96
			c0-39.6-27.6-69.2-77.6-69.2c-56.4,0-92,40.8-92,86.4c0,15.6,4.8,26.8,12.4,35.6c3.6,4,4,5.6,2.8,10c-0.8,3.2-2.8,11.2-4,14.4
			c-1.2,4.4-5.2,6.4-9.2,4.4c-26-10.4-38-38-38-69.2c0-51.2,44.8-112.8,133.2-112.8c71.2,0,118,50,118,103.6
			C377.6,269.2,337.2,322,277.2,322z"
                                            />
                                        </g>
                                    </g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </a>
                        )}
                </div>
            </div>
        );
    }

    renderPages() {
        return (
            <div className={this.state.className}>
                <div className="page-footer-page-links">
                    <b>Useful Links</b>
                    {this.props.pages.map((m, index) => (
                        <div key={"pages" + index} className="page-footer-links">
                            <a onClick={() => this.onPageClick(m)}>{m.Title}</a>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderCategories()
    {

        if(this.props.config.CheckoutConfig.hasOwnProperty("Menus") && this.props.config.CheckoutConfig.Menus.length > 0){
            //render mew menus
            return <div className={this.state.className}>
                <div className="page-footer-page-categories">
                    <b>Menu</b>
                    {this.props.config.CheckoutConfig.Menus.map((m, index) => <div
                       key={"categories" + index}
                       className="page-footer-links" 
                       onClick={()=>this.onMenuSelected(m)}
                        // onClick={() =>this.props.history.push(mainWebsitePath() +"l1/" +m.OMNITag)}
                    >
                        {m.Name}
                </div>)}
                </div>    
            </div>
        }
        else{
            //render online catgories that are in Menu
            return  <div className={this.state.className}>
                <div className="page-footer-page-categories">
                    <b>Menu</b>
                    {this.props.menu.filter((f) => f.ParentID === "").map((m, index) => (
                            <div
                                key={"categories" + index}
                                className="page-footer-links"
                                onClick={() =>
                                    this.props.history.push(
                                        mainWebsitePath() +
                                            "l1/" +
                                            m.OMNITag
                                    )
                                }
                            >
                                {m.Name}
                            </div>
                        ))}
                    </div>
                </div>
        }
    }

    returnYear(){
        const d = new Date();
        let year = d.getFullYear();
        return year;
    }

    showMenu(){
        let showMenu= true;
        if(this.props.config.CheckoutConfig.hasOwnProperty("PrivateCatalogue") 
            && this.props.config.CheckoutConfig.PrivateCatalogue){
            if(!this.props.customer){
                showMenu=false;
            }
        }

        return showMenu;
    }

    render() {
        // return <div style={{backgroundColor:"#efefef"}}>
        //     <br/>
        //     <br/>

        //     {this.props.pages.filter(f=>f.ShowInFooter).length > 0 && this.renderPages()}

        //     {(this.props.config.CheckoutConfig.hasOwnProperty('ShowContactDetailsInFooter') && this.props.config.CheckoutConfig.ShowContactDetailsInFooter ) && <React.Fragment >

        //         {this.renderContactDetails()}
        //     </React.Fragment>}

        //     {(this.props.config.CheckoutConfig.hasOwnProperty('ShowSocialMediaDetailsInFooter') && this.props.config.CheckoutConfig.ShowSocialMediaDetailsInFooter ) && <React.Fragment >
        //         {/* <br/>
        //         <br/> */}
        //         {this.renderSocialMediaDetails()}
        //     </React.Fragment>}
        //     <br/>
        //     <br/>
        // </div>

        return (<React.Fragment>
            <div className="page-footer">
                <br />
                <br />
                <div className="container">
                    <div className="row">
                        {this.props.config.CheckoutConfig.hasOwnProperty("ShowContactDetailsInFooter") 
                        && this.props.config.CheckoutConfig.ShowContactDetailsInFooter 
                        && this.renderContactDetails()}
                        
                        {this.showMenu() && this.renderCategories()}

                        {this.props.pages.filter((f) => f.ShowInFooter).length > 0 && this.renderPages()}

                        {this.props.config.CheckoutConfig.hasOwnProperty("ShowSocialMediaDetailsInFooter") 
                        && this.props.config.CheckoutConfig.ShowSocialMediaDetailsInFooter 
                        && this.renderSocialMediaDetails()}

                    </div>
                </div>
                <br />
                <br />
            </div>
            <div className="page-footer-copyright">
                <div className="container">
                Copyright {this.returnYear()} {this.props.config.BusinessName}, All rights reserved.
                </div>
            </div>
        </React.Fragment>);
    }
}

const mapStateToProps = (state) => ({
    menu: state.api.menu,
    config: state.api.config,
    pages: state.api.pages,
});

export default withRouter(connect(mapStateToProps, {})(PageFooter));
